import React, { useState } from "react";
import { Helmet } from 'react-helmet';
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { AppStateContext } from "../AppState";
import { CheckLogin } from "../shared/components/CheckLogin";
import { LoadingScreen } from "../shared/components/LoadingScreen";
import { platformService } from "../shared/services/platform.service";

export const GetAiFileFlow: React.FC = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const container = searchParams.get('cn') || '';
    const fileName = searchParams.get('fn') || '';
    
    const api = new platformService();
    const [isDownloaded, setIsDownloaded,] = useState<boolean>(false);
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(true);

    const loadPage = async () => {
        if (!isDownloaded) {
            await api.getAiFile(container, fileName);
            setIsDownloaded(true);
            setIsLoading(false);
        }
    };

    return (
        <AppStateContext.Consumer>
            {(state) => {
                return (
                    <CheckLogin onSignedIn={loadPage}>
                        <Helmet>
                            <title>{t('ai-configuration.downloadfile')}</title>
                        </Helmet>
                        <div className="hidden md:block">
                        {
                            (isLoading) ? 
                            <LoadingScreen message={`${t('ai-configuration.retrieving')} ${fileName}`} />: <div></div>
                        }
                        </div>
                    </CheckLogin>
                )
            }}
        </AppStateContext.Consumer>
    );
}